"use client";

import './index.css';
import { jsx } from 'react/jsx-runtime';
import { useState, useId, useEffect } from 'react';
import { validateSurface } from '../../globals.js';
import styles from './checkbox-group.module.scss.js';
import CheckboxGroupItem from './checkbox-group-item.js';

/**
 * @component Checkbox
 * @package Checbox
 * @document ../_docs/code/CheckboxGroup.editor.tsx
 * @document ../_docs/code/CheckboxGroup.snippet.tsx
 * @document ../_docs/code/CheckboxGroup.import.tsx
 */
const CheckboxGroup = ({ surface: surfaceProp = 'lightPrimary', items, width = '100%', onChange, id, viewport, required, }) => {
    const surface = validateSurface(surfaceProp);
    const [checkboxDataState, setCheckboxDataState] = useState(items);
    const componentId = useId();
    const surfaceStyles = styles[surface.toLowerCase()];
    useEffect(() => {
        setCheckboxDataState(items === null || items === void 0 ? void 0 : items.map((obj) => (Object.assign({}, obj))));
    }, [items]);
    /**
     * Grab checkbox's selected info via returnObj then re-set the checkboxDataState
     * then use updated checkboxDataState to check for new selected state to pass back to checkbox
     * @param returnObj returned from checkbox's onChange
     */
    const _handleChange = (e, returnObj, index) => {
        const { selected } = returnObj;
        const newData = checkboxDataState;
        /* istanbul ignore if -- @preserve */
        if (newData && newData[index]) {
            newData[index].selected = selected;
        }
        setCheckboxDataState(newData === null || newData === void 0 ? void 0 : newData.map((obj) => (Object.assign({}, obj))));
        /* istanbul ignore else -- @preserve */
        if (onChange) {
            onChange(e, newData);
        }
    };
    const checkboxGroupStyles = [
        styles.checkboxGroupWrapper,
        styles.viewpwort,
        surfaceStyles,
    ];
    if (viewport !== undefined) {
        checkboxGroupStyles.push(styles.viewport);
    }
    return (jsx("div", { className: checkboxGroupStyles.join(' '), id: id, children: items === null || items === void 0 ? void 0 : items.map((child, index) => (jsx(CheckboxGroupItem, Object.assign({ surface: surface, onChange: (e, returnObj) => _handleChange(e, returnObj, index), index: index, id: child.inputId || `${componentId}-${index}`, selected: checkboxDataState &&
                checkboxDataState[index] &&
                checkboxDataState[index].selected
                ? checkboxDataState[index].selected
                : false, required: required, viewport: viewport, width: width || child.width || '100%' }, child), index))) }));
};

export { CheckboxGroup, CheckboxGroup as default };
